import { BaseAPI } from './BaseAPI.js'
import { JasperReport, JasperReportControl } from '../types/index.js'

export default class JasperReportsAPI extends BaseAPI<JasperReport> {
  override get resource(): string {
    return '/jasperReports'
  }

  public async controls(
    id: number | string,
  ): Promise<Array<JasperReportControl>> {
    const result = await this._client.get(`jasperReports/${id}/controls`)

    return result.data
  }

  public async render(
    id: number | string,
    controls: { [key: string]: string } = {},
  ): Promise<string> {
    const result = await this._client.get(`jasperReports/${id}/render`, {
      params: controls,
    })

    return result.data
  }
}
